"use client";
import Link from "@/components/Link";
import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Row } from "@dxp-feed/ui/Row";
import { Text } from "@dxp-feed/ui/Text";
import { Columns } from "@dxp-feed/ui/Columns";
import { SiteContainer } from "@/components/Container";
import { addDataLayer } from "@/helpers/dataLayer";

export default function Social({ footerData }: any) {
  return (
    <Box as="div" className="bg-brandSecondary py-4 lg:!py-6" role="navigation">
      <SiteContainer>
        <Row className="pb-0 justify-between w-full">
          <Columns className="col-6 hidden lg:!block">
            <Box as="div" className="flex gap-6">
              <Box as="div" className="flex items-center gap-[24px]">
                <main>
                  <Text
                    as="span"
                    className="text-brandWhite text-body font-semibold leading-normal"
                  >
                    {footerData?.customerServiceTitle}
                  </Text>
                </main>
                {footerData?.horizontalList.map(
                  (horizontalItem: any, index: number) => (
                    <nav className="flex gap-6" key={index}>
                      <Link
                        href={horizontalItem?.link ?? "#"}
                        className="text-brandWhite text-body font-light leading-normal underline"
                        aria-label={horizontalItem.label}
                        key={horizontalItem?.label + index}
                        target={horizontalItem?.target}
                        scroll={true}
                        onClick={() =>
                          addDataLayer({
                            event: "nav_footer",
                            click_text: horizontalItem?.label,
                            click_url: horizontalItem?.link ?? "",
                            page_title: document?.title,
                          })
                        }
                      >
                        {horizontalItem?.label}
                      </Link>
                    </nav>
                  )
                )}
              </Box>
            </Box>
          </Columns>
          <Columns className="col-6 justify-end w-full lg:!w-auto mr-0 !pr-[0]">
            <Box as="div" className="flex gap-6 w-full">
              <Box
                as="div"
                className="flex items-center gap-[10px] w-full justify-end"
              >
                <main>
                  <Text
                    as="span"
                    className="text-brandWhite text-body font-normal leading-normal"
                  >
                    {footerData?.connectwithusTitle}
                  </Text>
                </main>
                <nav className="flex items-center gap-[10px]">
                  {footerData?.socialLinks.map(
                    (socialItem: any, index: number) => (
                      <Link
                        href={socialItem?.link ?? "#"}
                        className="text-sm"
                        key={socialItem?.label + index}
                        target={socialItem?.target}
                        aria-label={socialItem?.label}
                        onClick={() =>
                          addDataLayer({
                            event: "nav_footer",
                            click_text: socialItem?.label,
                            click_url: socialItem?.link ?? "",
                            page_title: document?.title,
                          })
                        }
                      >
                        <span
                          className={`${socialItem?.label} text-brandWhite text-base`}
                        ></span>
                      </Link>
                    )
                  )}
                </nav>
              </Box>
            </Box>
          </Columns>
        </Row>
      </SiteContainer>
    </Box>
  );
}
